export default __webpack_public_path__ + "static/media/rewards.480e8bd0.jpg";